module.exports = __webpack_public_path__ + "img/seperator_small.87f85d92.jpeg";